module.exports = __webpack_public_path__ + "img/icon4.1076319e.png";